module.exports = __webpack_public_path__ + "img/upload-icon.38fdc17.png";